<div id="chat_select" class="popup maintenance-form">
    <h2>Chat</h2>
    <div id="chat-grid">
        {#each Object.entries(chats) as [key, value]}
            <span>&nbsp;</span><span id="convention">{key}</span>
            {#each chats[key] || [] as chat}
                {#if chat != ''}
                    <span class="radio"><input type="radio" name="chat" value="{chat}"
                    on:click={() => copyChat(chat)}></span>
                    <span class="chat-text">{@html chat}</span>
                {/if}
            {/each}
        {/each}
    </div>
    <div class="button-grid">
        <button class="select-button" on:click={close}>Close</button>
    </div>
</div>

<style>
    #chat_select {
        display: none;
        top: 20vh;
        left: 20vw;
        width: 66vw;
    }
    #chat-grid {
        display: grid;
        grid-template-columns: 1vw auto;
    }

    .button-grid {
        margin: 0 auto;
        padding: 1vh;
    }

    .radio {
        font-size: 1em;
    }
    .chat-text{
        margin-top: -0.5vh;
    }

    #convention{
        color: green;
        margin: 1vh;
    }
</style>

<script>
    import { user } from './data-store';
    import { elementDisplay, setHTML, setText } from './utilities';
    import { suitToText, textToSuit } from './common'

    let convention_name = '';
    let first = '';

    $: conventions = getConventions($user);
    $: chats = getChats($user)

    function getConventions(user) {
        let conventions = [];
        for (const [convention, value] of Object.entries(user.conventions)) {
            conventions.push(convention);
        }
        conventions.sort();
        if (!convention_name && conventions.length > 0) {
            convention_name = conventions[0];
        }
        first = conventions[0];
        return conventions;
    }

function getChats(user) {
    let chats = {};
    let html = '';
    for (const [chat, value] of Object.entries(user.chat)) {
        let raw_chats = value.split('\n');
        let html_chat = [];
        for (let raw_chat of raw_chats) {
            if (raw_chat != '') {
                html = textToSuit(raw_chat);
                html_chat.push(html);
                chats[chat] = html_chat;
            }
        }
    }
    return chats;
}

    function displayConvention(convention) {
        elementDisplay('conventions', 'none')
        elementDisplay('convention-display', 'flex');
        setText('convention-title', convention);
        let text = textToSuit($user.conventions[convention])
        text = text.replaceAll('\n', '<br>')
        setHTML('convention-text', text);
        chats = []
        let raw_chats = $user.chat[convention].split('\n');
        for (var raw_chat of raw_chats) {
            var chat = textToSuit(raw_chat)
            chats.push(chat);
        }

    }

    function copyChat(chat) {
        let text = suitToText(chat)
        navigator.clipboard.writeText(text);
    }

    function close() {
        elementDisplay('conventions', 'none')
        elementDisplay('chat_select', 'none')

        var allRadios = document.getElementsByName('convention');
        var x = 0;
        for(x = 0; x < allRadios.length; x++){
            allRadios[x].checked = false;
        }
    }

</script>